import { PatientTreatmentListResponseDto } from "@/data/dto/patient-treatement-detail-list/patient-treatment-list-reponse-dto";
import { PatientTreatmentTotalInfoEntity } from "@/domain/entity/treatment/patient-treatment-total-info-entity";
import { calculateInternationalAge } from "@/utils/calculate-international-age";
import { getProgressType } from "@/utils/enum/progress-type";
import { assertPatientTreatmentListResponseDto } from "@/utils/validation";
import { PatientTreatmentDetailInfoListMapper } from "./patient-treatment-detail-list-info-mapper";

export class PatientTreatmentTotalInfoMapper {
  static toEntity(dto: PatientTreatmentListResponseDto): PatientTreatmentTotalInfoEntity {
    // AST 기반 타입 검증
    assertPatientTreatmentListResponseDto(dto);

    if (dto.guardian) {
      if (dto.guardian.phone && dto.guardian.phone.startsWith("+82")) {
        const phone = dto.guardian.phone.replace("+82", "0");
        // 숫자만 추출
        const onlyNumber = phone.replace(/[^0-9]/g, "");
        // 010으로 시작하는 11자리 번호일 때만 포맷 적용
        if (onlyNumber.length === 11 && onlyNumber.startsWith("010")) {
          dto.guardian.displayPhone = onlyNumber.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
        } else {
          dto.guardian.displayPhone = onlyNumber.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
        }
      } else if (dto.guardian.phone) {
        dto.guardian.displayPhone = dto.guardian.phone;
      } else {
        dto.guardian.displayPhone = "";
      }
    }

    let birthDay: string | null = null;
    if (dto.patient.birthDate) {
      birthDay = dto.patient.birthDate?.replace(/-/g, ".") ?? "";
    }

    let totalAdherence: string = "0";
    if (dto.sumRecommendedTotalPlayTime > 0) {
      totalAdherence = Math.floor(
        (dto.sumActuallyPlayTime / dto.sumRecommendedTotalPlayTime) * 100
      ).toString();
    }

    return {
      patientInfo: {
        ...dto.patient,
        birthDate: {
          date: birthDay ?? "",
          age: calculateInternationalAge(birthDay) ?? 0,
        },
      },
      guardianInfo: dto.guardian,
      currTreatmentStep: dto.currTreatmentStep,
      currTreatmentState: getProgressType(dto.currTreatmentState),
      totalAdherence: totalAdherence,
      sumActuallyPlayTime: dto.sumActuallyPlayTime,
      sumRecommendedTotalPlayTime: dto.sumRecommendedTotalPlayTime,
      treatmentDetails: dto.treatmentInfoList
        .sort((a, b) => b.step - a.step)
        .map((treatmentInfo) => PatientTreatmentDetailInfoListMapper.toEntity(treatmentInfo)),

      isInVisitDate: dto.isInVisitDate,
      isAccountExist: dto.isAccountExisting,
      voucher: dto.voucher ?? null,
    };
  }
}

// {
//     "patient": {
//         "fullName": "김오번",
//         "firstName": "",
//         "lastName": "",
//         "birthDate": "2025-08-22",
//         "gender": "male",
//         "memo": ""
//     },
//     "guardian": {
//         "fullName": "김광수",
//         "firstName": "",
//         "lastName": "",
//         "email": "",
//         "phone": "+821050367192"
//     },
//     "currTreatmentStep": 2,
//     "currTreatmentState": "inProgress",
//     "sumActuallyPlayTime": 0,
//     "sumRecommendedTotalPlayTime": 0,
//     "treatmentInfoList": [
//         {
//             "treatmentInfoUuid": "8049f90b-254b-49b9-87f1-dce82d082bfe",
//             "step": 2,
//             "state": "inProgress",
//             "startDate": "2025-08-27T00:00:00.000Z",
//             "endDate": "2025-12-03T00:00:00.000Z",
//             "actuallyExecutedDay": 0,
//             "recommendedExecutedDay": 0,
//             "actuallyPlayTime": 0,
//             "recommendedTotalPlayTime": 0,
//             "doctorName": "김광수"
//         }
//     ]
// }
